import * as React from 'react';
import { useState, useEffect } from 'react';
import { useAuth } from "../../services/auth";
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { HardwareFilterRequest, listHardwareModels, listCompanies } from '../../services/service'
import { FormDialog } from '../../components/FormDialog';
import { APISelectField } from '../APISelectField';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

export default function HardwareFilter(props) {
  const { user } = useAuth()
  const { childrenToParentValue } = props
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [hardwareModel, setHardwareModel] = useState('');
  const [hardwareCompany, setHardwareCompany] = useState('');
  const [listHardwareModelData, setListHardwareModelData] = useState([]);
  const [listCompaniesData, setListCompaniesData] = useState([]);
  const [filtersState, setFiltersState] = React.useState(false);

  const handleChangeManufacturer = (event) => {
    setHardwareModel(event.target.value);
  };


  const handleChangeCompany = (event) => {
    setHardwareCompany(event.target.value);
  };

  const filterRequest = () => {
    HardwareFilterRequest(hardwareCompany, hardwareModel).then((resp) => {
      childrenToParentValue(resp.data)
      setOpen(false)
      setFiltersState(true)
    })
  }

  useEffect(() => {

    listHardwareModels().then((response) => {
      setListHardwareModelData(response.data.results)

    })

    listCompanies().then((response) => {
      setListCompaniesData(response.data.results)
    })

  }, [])

  const clearFilter = () => {
    setHardwareCompany('')
    setHardwareModel('')
    HardwareFilterRequest('', '').then((resp) => {
      childrenToParentValue(resp.data)
      setOpen(false)
      setFiltersState(false)
    })
  }

  return (
    <div>
      <Row>
        <Col sm={1}>
          <Button variant="outlined" onClick={handleClickOpen}>
            Filtrar
          </Button>
        </Col>
        {
          filtersState
            ? (
              <Col sm={2}>
                <Button variant="outlined" color="error" onClick={clearFilter} type='submit' >
                  Limpar Filtro
                </Button>
              </Col>
            )
            : null
        }
      </Row>

      <FormDialog
        title={"Selecione os filtros desejados"}
        open={open}
        onDismiss={handleClose}
        formWidth={350}
        onSubmit={() => filterRequest()}
      >
        <APISelectField
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={hardwareModel}
          onChange={handleChangeManufacturer}
          label="Modelo de hardware"
        >
          <MenuItem key={""} value="">
            <em>Todas</em>
          </MenuItem>
          {listHardwareModelData.map((e) =>
            <MenuItem key={e.id} value={e.id}>
              {e.model}
            </MenuItem>
          )
          }
        </APISelectField>
        {user.is_staff ?
          <APISelectField
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={hardwareCompany}
            onChange={handleChangeCompany}
            label="Empresa"
          >
            <MenuItem value="">
              <em>Todas</em>
            </MenuItem>
            {listCompaniesData.map((e) => <MenuItem value={e.id}>{e.name}</MenuItem>)}
          </APISelectField>
          : null}
      </FormDialog>
    </div>
  );
}